import Assistance_section from "../../component/Services_Component/Assistance_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import {
    AssistanceSection,
    AssistanceSectionNew,
    BenefitSection,
    BoostSection,
    CustomSection,
    FAQ,
    LargeData,
    ServicesSection,
    roleWriting,
} from "../../Data/All_Services_Data/androidAppDevelopmentData";
import useMetaTags from "../../hooks/useMetaTags";


const AndroidAppDevelopmentServices = () => {
    useMetaTags({
        title:
            "Expert Android App Development Services | Warrgyizmorch",
        description:
            "Get reliable Android app development with Warrgyizmorch. We create smart, user-friendly mobile apps tailored to your business goals. Get started today!",
        keywords:
            "android app development, android app development agency, android app development company, android developer, android application development, Native App Development, Android App Testing, iOS App Development, mobile app development",
    });
    return (
        <>
            <section
                className=""
                style={{
                    backgroundImage: `url('assets/img/service/serviceD.jpg')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                id="service-sec"
            >
                <div className="round-container pt-5">
                    <div className="container">
                        <div className="title-area text-center">
                            <span className="sub-title text-white">OUR SERVICES</span>
                            <h1 className="sec-title text-white">
                                Android App Development - Warrgyizmorch
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-extra-bottom">
                <div className="page-single">
                    <div className="page-content">
                        <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
                        {/* Intro part  */}
                        <div
                            className="header-section container"
                            style={{ marginTop: "20px" }}
                        >
                            <img
                                src="assets/img/icon/mobile app.jpg"
                                loading="lazy"
                                alt="heading_image"
                            />
                            <div>
                                <p>
                                    Warrgyizmorch places great importance on innovation in Android app development to match your business ambitions and fulfil user demands. Focused on progress, our Android app agency proudly delivers mobile solutions that work efficiently, keep data secure, and make interfaces simple for everyone. Start-ups and big enterprises alike benefit as our skilled Android developer build applications designed to boost business growth, encourage user engagement, and satisfy client needs in any industry. Balancing creative thinking, smart planning, and technical skill, our team handles every part of mobile app development to suit android app development agency modern standards. We always put usability, strong features, and speed at the centre so your Android app gains visibility even in busy marketplaces. With careful attention, each application gets precisely developed and tuned for steady performance across countless Android devices.
                                </p>
                            </div>
                        </div>

                        <Handle_Largedata_section LargeData={LargeData} />

                        <Benefits_section data={BenefitSection} />

                        <Assistance_section data={AssistanceSectionNew} />                        

                        {/* FAQ section  */}
                        <FAQ_section data={FAQ} />
                    </div>
                </div>
            </section>
            <div className="scroll-top">
                <svg
                    className="progress-circle svg-content"
                    width="100%"
                    height="100%"
                    viewBox="-1 -1 102 102"
                >
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 10ms linear 0s",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: "307.919",
                        }}
                    ></path>
                </svg>
            </div>
        </>
    )
}

export default AndroidAppDevelopmentServices